import React, { useEffect, useState } from "react";
import { eventRoomStore } from "@/stores/event";
import NoSignal from "../../assets/signal/no_sig.svg";
import signal1 from "../../assets/signal/1.svg";
import signal2 from "../../assets/signal/2.svg";
import signal3 from "../../assets/signal/3.svg";
import signal4 from "../../assets/signal/4.svg";
import signal5 from "../../assets/signal/5.svg";
import NetworkPopup from "./NetworkPopUp";
import SignalCellularConnectedNoInternet0BarIcon from "@mui/icons-material/SignalCellularConnectedNoInternet0Bar";
import "./network-indicator.scss";

const NetworkIndicator = () => {
  const [networkQuality, setNetworkQuality] = useState(0);
  useEffect(() => {
    const webClient = eventRoomStore.rtcClient;

    const handleNetworkQuality = ([stats]: any) => {
      const downlink = stats?.downlinkNetworkQuality || 0;
      const uplink = stats?.uplinkNetworkQuality || 0;
      const worstQuality = Math.max(downlink, uplink);
      const quality = worstQuality === 0 ? 0 : Math.max(0, 6 - worstQuality);

      setNetworkQuality(quality);
      eventRoomStore.setNetworkQuality(quality);
    };

    webClient.rtc.on("network-quality", handleNetworkQuality);

    return () => {
      webClient.rtc.off("network-quality", handleNetworkQuality);
    };
  }, []);

  return (
    <>
      {networkQuality < 1 ? (
        <NetworkPopup />
      ) : (
        <div className="network-signal-container">
          {networkQuality == 0 && (
            <>
              <img src={NoSignal} />
            </>
          )}
          {networkQuality == 1 && (
            <div className="network-signal-container-blink">
              {/* <img src={signal1} /> */}
              <SignalCellularConnectedNoInternet0BarIcon />
            </div>
          )}
          {networkQuality == 2 && (
            <div className="network-signal-container-blink">
              {/* <img src={signal2} /> */}
              <SignalCellularConnectedNoInternet0BarIcon />
            </div>
          )}
          {networkQuality == 3 && (
            <>
              <img src={signal3} />
            </>
          )}
          {networkQuality == 4 && (
            <>
              <img src={signal4} />
            </>
          )}
          {networkQuality == 5 && (
            <>
              <img src={signal5} />
            </>
          )}
        </div>
      )}
    </>
  );
};

export default React.memo(NetworkIndicator);
